import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { getFilenameFromURL, capitalizeFirstLetterOfEachWord } from "../../utils/common_functions";
import { apiCall } from "../../utils/server_utils";
import CommonIcon from '../common/customicon';
import Message from "../common/message";
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import * as ReactDOM from 'react-dom';
import {trackError} from "../../utils/error_tracker"
import "datatables.net";
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.css";
import {getAllClauses} from "../../services/admin"
import $ from "jquery";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';


let  document_json  = [
{
  'document_name':"test.pdf",
  'clause_name':"Notice",
  'threshold':1,
  'days_remaining':"10 days"
}
]
export const Alert = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // API data for documents
  const [clausesData, setClausesData] = useState(["Property", "Channel", "Customer", "Product type", "Category", "Territory", "Gender"]); // Clause options
  const [filterTextDocuments, setFilterTextDocuments] = useState(""); // For document filtering
  const [filterTextClauses, setFilterTextClauses] = useState(""); // For clause filtering
  const [selectedDocument, setSelectedDocument] = useState(null); // Selected document
  const [selectedClauses, setSelectedClauses] = useState([]); // Selected clauses
  const [selectedDocuments, setSelectedDocuments] = useState([]); // Track selected documents
  const [alertTime, setAlertTime] = useState(50); // Initial value
  const [alertData,setAlertData] = useState(document_json); // API data for documents
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  
   //#-- Tab
 const [activeTab, setActiveTab] = useState('Active Alerts');  // State for active tab
 const handleTabChange = (tabId) => {
   setActiveTab(tabId);
 };
 //#--


  const [deletedocumentmodal, setDeleteDocumentModal] = useState(false);
  const handleDeleteClose = () => setDeleteDocumentModal(false);
  const handleDeleteShow = () => setDeleteDocumentModal(true);

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };
  

  useEffect(() => {
    // Fetch data from the API
    const fetchContracts = async () => {
        setLoading(true); // Stop loading spinner
      try {
        const result = await apiCall("GET", `${API_SERVER_URL}contracts/`);
        if (result.code === API_SUCCESS_RESPONSE_CODE) {
          setData(result.data);
          setLoading(false);  
        }
      } catch (error) {
        setLoading(false);  
        console.error("Error fetching contracts", error);
      }
    };

    const fetchClauses = async () => {
      setLoading(true); // Stop loading spinner
    try {
      const result = await getAllClauses();
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        const clauseNamesArray = result.data.map(item => item.clauseName);
        setClausesData(clauseNamesArray);
        setLoading(false);  
      }
    } catch (error) {
      setLoading(false);  
      console.error("Error fetching contracts", error);
    }
  };

    
    fetchClauses();
    fetchContracts();
  }, []);


  useEffect(() => {
    // let  document_json  = [
    //   {
    //     'document_name':"test.pdf",
    //     'clause_name':"Notice",
    //     'threshold':1,
    //     'days_remaining':"10 days"
    //   }
    //   ]

    if (alertData.length > -1) {


      const table = $("#contract_grid").DataTable({
        scrollCollapse: true,
       // "dom": '<"top"f>rt<"bottom"l p><"clear">',  // Length menu (l) before pagination (p)
        //   dom: '<"float-left"B><"float-right"f>rt<"row"<"col-sm-4"l><"col-sm-4"i><"col-sm-4"p>>',
        scrollX: true,
        pageLength: 25, // Set default number of records per page
        scrollY:$(window).height()-($("#table_height").height()+180),
        data: alertData,
        destroy: true, // Ensure the previous table is destroyed
        order: [],  // This disables default sorting on any column
        "columnDefs": [
          { "className": "text-center", "targets": -1 }, // Last column center-aligned
          { "className": "text-left", "targets": "_all" } // All other columns left-aligned
        ],
        columns: [
          {
            data: "document_name",
            title: "Contract Name",
            width: "200px",
            render: function (data, type, row) {
              return getFilenameFromURL(data);
            }
          },
          { data: "clause_name", title: "Clause Name", width: "40px",
            render: function (data, type, row) {
              return  data;
            }
          },
          { data: "threshold", title: "Threshold Value", width: "40px",
            render: function (data, type, row) {
              return  data+"&nbsp";
            }
          },
          {
            data: "days_remaining",
            title: "Days Remaining",
            width: "40px",
            render: function (data, type, row) {
              return  data;
            }

          },
          {
            title: "Actions",
            orderable: false, // Disable sorting for this column
            data: null,
            width: "60px", 
            createdCell: function (td, cellData, rowData, row, col) {
              // Clear the default HTML and replace it with React-rendered content
              ReactDOM.render(
                <>
                  <OverlayTrigger
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    placement="top"
                    overlay={<Tooltip id="delte-top">Delete</Tooltip>}
                  >
                  <a href="javascript:void(0);" className="delete-btn" data-bs-toggle="modal"
                     data-bs-target="#confirmationModal" data-id={rowData._id} data-name={rowData.FilePath}>
                    <i className="datatable-delete-icon"></i>
                  </a></OverlayTrigger>
                  &nbsp;
                </>,
                td // Render the content directly into the table cell
              );
            }
          },
        ],
        paging: true,
        searching: false,
        ordering: true,
        responsive: true,
        fixedHeader: true,
        language: {
          emptyTable: "No data found matching the filters",  // Custom message for no data
        },
      });

      setTimeout(function() {
      table.columns.adjust().draw();

    }, 100); // Adjust the delay time based on your sidebar transition duration


      $('.menu-icon').on('click', function() {
        // Adjust DataTable columns and redraw when the sidebar menu is toggled
        setTimeout(function() {
          table.columns.adjust().draw();
        }, 100); // Adjust the delay time based on your sidebar transition duration
      });

      $('.menu-icon').on('click', function() {
        // Adjust DataTable columns and redraw when the sidebar menu is toggled
        setTimeout(function() {
          table.columns.adjust().draw();
        }, 100); // Adjust the delay time based on your sidebar transition duration
      });

      

      $("#contract_grid").on("click", ".delete-btn", function () {
        handleDeleteShow()
        const id = $(this).data("id");
        const name = getFilenameFromURL($(this).data("name"));
        setTimeout(function() {
          $("#btn_delete").attr("data-id", id);
          $("#document_name").html(name);
        }, 200);
      });
      return () => {
        table.destroy(); // Clean up DataTable instance
      };
    }
  }, [data,clausesData,alertData]);

  const resetform = () => {
    setSelectedClauses([])
    setSelectedDocument(null);
    setEmail("")
    $("#emailInput").val("")
    setSelectedDocuments([])
    var uncheck=document.getElementsByTagName('input');
    for(var i=0;i<uncheck.length;i++)
    {
     if(uncheck[i].type=='checkbox')
     {
      uncheck[i].checked=false;
     }
    }
  }

  // Filter documents based on the search text
  const filteredDocuments = data.filter((doc) =>
    getFilenameFromURL(doc.FilePath).toLowerCase().includes(filterTextDocuments.toLowerCase())
  );

  // Filter clauses based on the search text
  const filteredClauses = clausesData.filter((clause) =>
    clause.toLowerCase().includes(filterTextClauses.toLowerCase())
  );

  const handleDocumentSelectionBatch = (doc) => {
    const isSelected = selectedDocuments.find(selected => selected._id === doc._id);
    if (isSelected) {
      setSelectedDocuments(selectedDocuments.filter(selected => selected._id !== doc._id));
    } else {
      setSelectedDocuments([...selectedDocuments, doc]);
    }
  };

    // **Select All Documents** functionality
    const handleSelectAllDocuments = (e) => {
      if (e.target.checked) {
        setSelectedDocuments(filteredDocuments);
      } else {
        setSelectedDocuments([]);
      }
    };
  
    // **Select All Clauses** functionality
    const handleSelectAllClauses = (e) => {
      if (e.target.checked) {
        setSelectedClauses(filteredClauses);
      } else {
        setSelectedClauses([]);
      }
    };


  // Handle clause selection
  const handleClauseSelection = (clause) => {
    if (selectedClauses.includes(clause)) {
        setSelectedClauses(selectedClauses.filter((c) => c !== clause));
      } else {
        setSelectedClauses([...selectedClauses, clause]);
      }
  };


  const startReRun = async () => {
    let apiUrl = API_SERVER_URL+ 'rerun/'
    let method = "POST"
    validateEmail()
    let request_object = {}
    const targetElement = document.getElementById("app_err");
    request_object.doc_ids = selectedDocuments.map(item => item._id);
    request_object.clauses = selectedClauses

    let arr_file_path = selectedDocuments.map(item => item.FilePath);
    let str_clause = Array.isArray(selectedClauses) ? selectedClauses : selectedClauses.split(",");

    let temp = [];
    for(let loop=0;loop<arr_file_path.length;loop++){
      let obj = {
        'document_name':getFilenameFromURL(arr_file_path[loop]),
        'clause_name':str_clause,
        'threshold':$("#myRange").val(),
        'days_remaining':$("#myRange").val()+" days"

      }
      temp.push(obj)
    }
    let mergedArray = [...temp, ...alertData];
    setAlertData(mergedArray)
    if (targetElement) {
      ReactDOM.unmountComponentAtNode(targetElement);
    }
    ReactDOM.render(<Message type='success' message="Document Alert Added" />, targetElement);
    resetform()
    handleTabChange('Active Alerts')
    return;
    try {
        const result = await apiCall(method,apiUrl,request_object);
        const targetElement = document.getElementById("app_err");
        if(result!==undefined){
        if (result.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
           
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
            resetform()
        } else {
          if (targetElement) {
            ReactDOM.unmountComponentAtNode(targetElement);
          }
          ReactDOM.render(<Message type='error' message={result.message} />, targetElement);
          trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
        }
        }
    } catch (error) {
      console.error("Error:", error);
    }
    }

    const handleEmailChange = (e) => {
      const value = e.target.value;
      setEmail(value);
    
      if (!value) {
        setError("Email is required.");
        setIsEmailValid(false);
      } else if (!validateEmail(value)) {
        setError("Invalid email format.");
        setIsEmailValid(false);
      } else {
        setError("");
        setIsEmailValid(true);
      }
    };

    
  const reRunClausesByDocument =() => {
    startReRun()
  }
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
            <div className="flex-grow-1" id="row_heading">
              <div className="page-title">Contract Alert Settings</div>
              <p className="text-muted my-2 ff-secondary">
                  Configure when and how you want to receive notifications about your contracts
              </p>
            </div>
            <div id="app_err"></div>
          </div>
            {loading ? (
                 <PageLoader />
            ) :  data.length > 0 ?
            <>


<div style={{ width: "30%" }}
          >
          <div className="card">
          <div className="card-body" style={{padding:"5px"}}>
          <ul className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
                <li className="nav-item">
                   <a             className={`nav-link fs-14 ${activeTab === 'Active Alerts' ? 'active' : ''}`} 
            data-bs-toggle="tab" 
            href="javascript:void(0)" 
            role="tab"
            onClick={() => handleTabChange('Active Alerts')}
>
                   <i className="ri-airplay-fill d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="Bell" size={"17px"} color={activeTab === 'Active Alerts' ? '#fff' : '#000'}  /> Active Alerts</span>
                   </a>
                </li>
                <li className="nav-item">
                   <a className={`nav-link fs-14 ${activeTab === 'Alert Settings' ? 'active' : ''}`} 
            data-bs-toggle="tab" 
            href="javascript:void(0)" 
            role="tab"
            onClick={() => handleTabChange('Alert Settings')}
>
                   <i className="ri-list-unordered d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="Settings" size={"17px"} color={activeTab === 'Alert Settings' ? '#fff' : '#000'}  /> Alert Settings</span>
                   </a>
                </li>
             </ul>
          </div>
          </div>
          </div>

         
          <div  className={activeTab === "Alert Settings" ? '' : 'd-none'} >
              <div className="row">
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-body">

                      
                    <div className="col-sm-12">
                              <h5>Delivery Method</h5>
                              </div>
                              <p class="alert-desc small">Select your preferred method for receive notifications about your contracts</p>

                              <div class="radio-group">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="deliveryMethod" id="emailOption" checked />
                        <label class="form-check-label" for="emailOption">Email</label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="deliveryMethod" id="serviceNowOption" />
                        <label class="form-check-label" for="serviceNowOption">ServiceNow</label>
                    </div>
                </div>


                <div class="mt-3">
                    <label for="emailInput" class="form-label">Email Address</label>
                    <input
                      type="email"
                      value={email}
                      className={`form-control ${error ? "is-invalid" : ""}`}
                      id="emailInput"
                      placeholder="user@domain.com"
                      onChange={handleEmailChange}
                    />
                    {error && <div className="invalid-feedback">{error}</div>}
                </div>


                    </div>
                    </div>
                    </div>


                    <div className="col-lg-6">
                  <div className="card">
                    <div className="card-body" style={{height:"196px"}}>

                    <div className="col-sm-12">
                              <h5>Alert Timing</h5>
                              </div>
                              <p class="alert-desc">Set how many days in advance you want to be notified</p>

                              <div class="slider-label">
                    <span className='alert-time-text'>Days before due date</span>
                    <span id="daysOutput">&nbsp;</span>
                    <span className='alert-time-text'>{alertTime} days</span>
                </div>

                <input
        type="range"
        min="1"
        max="180"
        value={alertTime}
        className="range-slider"
        id="myRange"
        onChange={(e) => setAlertTime(e.target.value)}
      />


<div class="slider-label">
                    <span>0 days</span>
                    <span>&nbsp;</span>
                    <span>180 days</span>
                </div>





                    </div>
                    </div>
                    </div>

                    </div>


              <div className="row">
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-body" style={{height:"450px"}}>
                      {/* Document Search */}
                      <div className="row g-2 mb-4 mt-1" id="row_search">

                             <div className="col-sm-6">
                              <h5>Contract Selection</h5>
                              </div>
                              <div className="col-sm-6"  style={{margin:"0px"}}>
                              <label className='highlight-clause float-end' style={{margin:"0px"}}>
                                {
                                selectedDocuments.length > 0 ? selectedDocuments.length > 1 ? selectedDocuments.length+" documents selected": selectedDocuments.length+" document selected" : "" }
                                </label>
                              </div>
                              <p class="alert-desc">Configure when and how you want to receive notifications about your contracts</p>
                        <div className="col-sm-12">
                          <div className="search-box">
                            <input
                              type="text"
                              className="form-control"
                              id="searchDocuments"
                              placeholder="Search documents..."
                              value={filterTextDocuments}
                              onChange={(e) => setFilterTextDocuments(e.target.value)}
                            />
                            <i className="grid-search">
                              <CommonIcon iconName="Search" size={"14px"} />
                            </i>
                          </div>
                        </div>
                      </div>
                      {/* Document List */}
                     
                      <div className="card">
                      <div className='card-heading'><div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={'SelectAllDocuments'}
                                        onChange={handleSelectAllDocuments}
                                        checked={selectedDocuments.length === filteredDocuments.length && filteredDocuments.length > 0}
            
                                      />
                                      <label className="form-check-label" htmlFor={`SelectAllDocuments`}>
                                      Select All Contract
                                      </label>
                                </div></div>
                        <div className="card-body no-padding">
                          <div style={{ height: "200px", overflow: "auto","margin":"5px" }}>
                          {filteredDocuments.map((doc) => (
                        <div className="document-row" key={doc._id} onClick={() => handleDocumentSelectionBatch(doc)}
                        
                        style={{
                          border: selectedDocuments.includes(doc) ? '0px solid #007bff' : '0px solid #ccc',
                          borderRadius:"10px",
                          padding: '10px',
                          marginBottom: '5px',
                          cursor: 'pointer',
                          backgroundColor: selectedDocuments.includes(doc) ? '#f3f4f5' : '#fff',
                        }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`doc-${doc._id}`}
                              checked={selectedDocuments.some(selected => selected._id === doc._id)}
                              onChange={() => handleDocumentSelectionBatch(doc)}
                            />
                          </div>
                          <div>
                            <CommonIcon iconName="FileText" size={"17px"} color="#6B7280" />
                          </div>
                          <div className="document-info ml-5">
                            <h6>{getFilenameFromURL(doc.FilePath)}</h6>
                            <p>Last processed: {doc.importdate}</p>
                          </div>
                        </div>
                      ))}
                        {filteredDocuments.length===0 ? "No Contract Found" : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                <div className="card">
                <div className="card-body" style={{height:"450px"}}>

                <>
                          <div className="row g-2 mb-4 mt-1">
                            <div className="col-sm-6">
                              <h5>Clause Selection</h5>
                              </div>
                              <div className="col-sm-6"  style={{margin:"0px"}}>
                              <label className='highlight-clause float-end' style={{margin:"0px"}}>
                                {
                                selectedClauses.length > 0 ? selectedClauses.length > 1 ? selectedClauses.length+" clauses selected": selectedClauses.length+" clause selected" : "" }
                                </label>
                              </div>
                              <p class="alert-desc">Select which clauses should trigger alert</p>
                              <div className="search-box">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="searchClauses"
                                  placeholder="Search clauses..."
                                  value={filterTextClauses}
                                  onChange={(e) => setFilterTextClauses(e.target.value)}
                                />
                                <i className="grid-search">
                                  <CommonIcon iconName="Search" size={"14px"} />
                                </i>
                             
                            </div>
                          </div>
                          {/* Clauses List */}
                          <div className="card">
                            <div className="card-body no-padding">
                              <div className='card-heading'>
                                
                              <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={'SelectAllClauses'}
                                        onChange={handleSelectAllClauses}
                                        checked={selectedClauses.length === filteredClauses.length && filteredClauses.length > 0}
                                      />
                                      <label className="form-check-label" htmlFor={`SelectAllClauses`}>
                                      Select All Clauses
                                      </label>
                                </div></div>
                              <div style={{ height: "200px", overflow: "auto","margin":"5px"  }}>
                                {filteredClauses.map((clause, index) => (
                                  <div  key={index}
                                  style={{
                                    border: selectedClauses.includes(clause) ? '0px solid #007bff' : '0px solid #ccc',
                                    borderRadius:"10px",
                                    padding: '10px',
                                    marginBottom: '5px',
                                    cursor: 'pointer',
                                    backgroundColor: selectedClauses.includes(clause) ? '#f3f4f5' : '#fff',
                                  }}
                                  >
                                    <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`flexCheckDefault_${index}`}
                                      // Check if the clause is in the selectedClauses array
                                      checked={selectedClauses.includes(clause)}
                                      // Toggle clause selection
                                      onChange={() => handleClauseSelection(clause)}
                                    />
                                    <label className="form-check-label" htmlFor={`flexCheckDefault_${index}`}>
                                      {clause}
                                    </label>
                                  </div>

                                  </div>
                                ))}
                                {filteredClauses.length===0 ? "No Clauses Found" : ""}
                              </div>
                             
                            </div>
                          </div>
                        </>

                </div>
                </div>  
                </div>  
              </div> 
               {/* Re-Run All Clauses Button (enabled only when document is selected) */}
               <div className="row">
               <div className="col-lg-12">
                 <button
                   className="btn btn-primary float-end"
                   onClick={reRunClausesByDocument}
                   disabled={!selectedClauses.length || !selectedDocuments.length || !isEmailValid}  // Disabled if no document or clauses are selected
                   >
                   <CommonIcon iconName="Save" size={"14px"} color="#fff" /> Save Alert Settings 
                 </button>
               </div>
             </div>

              <br/>    
              </div>
                                  
             <div className={activeTab === "Active Alerts" ? 'row' : 'row d-none'}>
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      
                    <div className="col-sm-12">
                              <h5 className='mb-3'>Active Alerts</h5>
                              </div>

             <table
                      id="contract_grid"
                      className="display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                      </thead>
                    </table>
                    </div>
                    </div>
                    </div>
              </div>
               
             </>
              : ""}
            </div>
      </div>
    </div>
  );
};